<template>
    <!-- modal-xl -->
    <b-modal id="addSuppliersModal" size="xxxl" title="Add Suppliers" title-class="font-18" hide-footer>
        <b-overlay :show="show">
            <div class=" d-flex justify-content-between">
                <!-- input for file to upload -->
                <div>
                    <b-form-group class="upload-max-width">
                        <b-form-file @change="handleFileUpload"></b-form-file>
                    </b-form-group>
                </div>
                <div class="mr-3">
                    <b-button variant="primary" class="btn-label" src="@/assets/images/beesmart-logo.png" @click="downloadFile">
                        <i class="mdi mdi-download mr-1 label-icon"></i>
                        Download Input Sheet
                    </b-button>
                </div>
            </div>

            <div v-if="this.data_set == false && this.fileError != true" class="">Upload the excel sheet with your suppliers</div>
            <div v-if="fileError" class="">File error</div>
            <div v-else-if="suppliers_to_add.length > 0 || suppliers_to_update.length > 0">
                <h5 v-if="this.data_set == true" class=" mt-2 mb-3 text-danger">Changes will only apply when saved</h5>

                <div v-if="suppliers_to_update.length > 0" class="mb-4">
                    <SuppliersToUpdatedTable />
                </div>
                <div v-else class="ml-2"></div>

                <div v-if="suppliers_to_add.length > 0">
                    <SuppliersToAddTable />
                </div>
            </div>

            <div class="modal-footer mt-3">
                <b-button v-if="saveEnabled && this.fileError != true" @click="save" variant="primary" type="button" class="btn btn-primary">
                    Save
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Cancel
                </b-button>
            </div>

            <!-- Modals -->
        </b-overlay>
    </b-modal>
</template>

<script>
import Swal from "sweetalert2";
import SuppliersToUpdatedTable from "../suppliers/tables/suppliersToUpdatedTable.vue";
import SuppliersToAddTable from "../suppliers/tables/suppliersToAddTable.vue";
//eslint-disable-next-line
import { read, utils } from "xlsx";
import { suppliersComputed, suppliersMethods } from "@/state/helpers";

export default {
    components: { SuppliersToUpdatedTable, SuppliersToAddTable },
    data: () => ({
        show: false,
        saveEnabled: false,
        data_set: false,
        fileError: false,
    }),
    computed: {
        ...suppliersComputed,
    },
    methods: {
        ...suppliersMethods,
        closeModal() {
            this.$bvModal.hide("addSuppliersModal");
        },
        async handleFileUpload(event) {
            this.fileError = false;
            const file = event.target.files[0];

            if (typeof file !== "undefined") {
                this.show = true;
                // const f = await (await fetch("https://sheetjs.com/pres.xlsx")).arrayBuffer();
                const f = await file.arrayBuffer();
                const wb = read(f);
                const data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);

                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        //see if properties are in the object in the array
                        //eslint-disable-next-line
                        let cn = "supplier_name" in data[i];
                        let vn = "vat_no" in data[i];
                        let cr = "company_reg" in data[i];

                        //eslint-disable-next-line
                        console.log("cn", cn, "vn", vn, "cr", cr);
                        if (cn == false || vn == false || cr == false) {
                            this.fileError = true;
                            break;
                        }
                    }

                    //file ahs no errors
                    if (this.fileError == false) {
                        this.checkBeforeAddSuppliers({ client_id: this.$route.params.client_id, data: data }).then(() => {
                            this.saveEnabled = true;
                            this.show = false;
                            this.data_set = true;
                        });
                    }
                } else {
                    this.fileError = true;
                    this.show = false;
                }
                this.show = false;
            }
        },
        // saveAddUpdateSuppliers
        save() {
            this.show = true;

            Swal.fire({
                // title: `Save? `,
                text: `Are you sure you would like to update or add these suppliers?`,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Save",
            }).then((result) => {
                if (result.value) {
                    this.saveAddUpdateSuppliers({
                        client_id: this.suppliers_client_details.client_id,
                        update: this.suppliers_to_update,
                        add: this.suppliers_to_add,
                    }).then(() => {
                        this.setSuppliers(this.$route.params.client_id);

                        Swal.fire("", "Successfully saved", "success");

                        this.closeModal();
                    });
                } else {
                    this.show = false;
                }
            });
        },
        downloadFile() {
            // Create a link element
            const link = document.createElement("a");
            link.href = "/book-testing.xlsx"; // Replace with the actual path to your file
            link.download = "book-testing.xlsx"; // Replace with the desired file name and extension

            // Programmatically trigger the download
            link.click();
        },
    },
    mounted() {},
    beforeDestroy() {
        this.resetAddSuppliersToEmpty();
    },
};
</script>

<style lang="scss">
.upload-max-width {
    width: 450px;
}
.modal-xxxl {
    width: 100%;
    max-width: 1550px;
}
</style>
